<template>
  <section class="mobile-images">
    <!-- 홍보 이미지들 -->
    <template v-for="(image, index) in images" :key="index">
      <div class="image-wrapper">
        <img
          :src="image"
          :alt="`홍보 이미지 ${index + 1}`"
          loading="lazy"
        />
      </div>

      <!-- home3 뒤 사업개요 표 -->
      <div v-if="index === 2" class="info-table-section">
        <h3 class="info-table-title">사업개요</h3>
        <table class="info-table">
          <tbody>
            <tr>
              <th>사업명</th>
              <td>대전광역시 용전동 72-1 주상복합 신축공사</td>
            </tr>
            <tr>
              <th>대지위치</th>
              <td>대전광역시 동구 용전동 72-1 외 13필지</td>
            </tr>
            <tr>
              <th>대지면적</th>
              <td>5,361.3 ㎡</td>
            </tr>
            <tr>
              <th>연면적</th>
              <td>60,281.9374 ㎡</td>
            </tr>
            <tr>
              <th>건축면적</th>
              <td>3,745.8350 ㎡</td>
            </tr>
            <tr>
              <th>지역지구</th>
              <td>일반상업지역, 방화지구, 시가지경관지구, 중점경관관리구역</td>
            </tr>
            <tr>
              <th>공급규모</th>
              <td>지하 1층 ~ 지상 46층 / 아파트 274세대, 오피스텔 36실 총 310세대</td>
            </tr>
            <tr>
              <th>건폐율/용적률</th>
              <td>69.86%(법정 70%이하) / 771.04%(법정 800%)</td>
            </tr>
            <tr>
              <th>주차계획</th>
              <td>464대(법정대비 135.88%)<br/>[아파트 369대, 오피스텔 48대, 근생 47대]</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <!-- 하단 관심고객등록 폼 -->
    <div class="inline-form-section">
      <div class="form-header">
        <span class="form-badge">CONTACT</span>
        <h3 class="form-title">관심고객등록</h3>
        <p class="form-desc">연락처를 남겨주시면 담당자가 빠르게 연락드립니다</p>
      </div>

      <form @submit.prevent="submitForm" class="register-form">
        <div class="form-group">
          <input
            type="text"
            v-model="form.name"
            placeholder="이름"
            required
            :disabled="isSubmitting"
          />
        </div>
        <div class="form-group">
          <div class="phone-inputs">
            <input
              ref="phone1"
              type="tel"
              inputmode="numeric"
              v-model="form.phone1"
              placeholder="010"
              maxlength="3"
              required
              :disabled="isSubmitting"
              @input="onPhoneInput('phone1', 3, 'phone2')"
            />
            <span class="phone-dash">-</span>
            <input
              ref="phone2"
              type="tel"
              inputmode="numeric"
              v-model="form.phone2"
              placeholder="0000"
              maxlength="4"
              required
              :disabled="isSubmitting"
              @input="onPhoneInput('phone2', 4, 'phone3')"
            />
            <span class="phone-dash">-</span>
            <input
              ref="phone3"
              type="tel"
              inputmode="numeric"
              v-model="form.phone3"
              placeholder="0000"
              maxlength="4"
              required
              :disabled="isSubmitting"
              @input="onPhoneInput('phone3', 4, null)"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="field-label">방문예약 희망 일자/시간</label>
          <div class="visit-inputs">
            <div class="visit-field">
              <input
                type="date"
                v-model="form.visitDay"
                :disabled="isSubmitting"
              />
              <span v-if="!form.visitDay" class="visit-placeholder">날짜 선택</span>
            </div>
            <div class="visit-field">
              <input
                type="time"
                v-model="form.visitTime"
                :disabled="isSubmitting"
              />
              <span v-if="!form.visitTime" class="visit-placeholder">시간 선택</span>
            </div>
          </div>
        </div>
        <label class="checkbox-label">
          <input type="checkbox" v-model="form.agree" required :disabled="isSubmitting" />
          <span class="checkmark"></span>
          <span>개인정보 수집 및 이용 동의</span>
        </label>
        <button type="submit" class="submit-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '등록 중...' : '상담 신청하기' }}
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { saveConsultation } from '@/firebase/consultationService'

export default {
  name: 'MobileImageSection',
  data() {
    return {
      images: [],
      isSubmitting: false,
      form: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      }
    }
  },
  created() {
    const exts = ['jpg', 'gif', 'png']
    for (let i = 1; i <= 20; i++) {
      for (const ext of exts) {
        try {
          const img = require(`@/assets/mobile/home${i}.${ext}`)
          this.images.push(img)
          break
        } catch (e) {
          // 다음 확장자 시도
        }
      }
    }
  },
  methods: {
    onPhoneInput(field, maxLen, nextRef) {
      this.form[field] = this.form[field].replace(/[^0-9]/g, '')
      if (this.form[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.form.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        const result = await saveConsultation({
          name: this.form.name,
          phone: `${this.form.phone1}-${this.form.phone2}-${this.form.phone3}`,
          visitDate: this.form.visitDay && this.form.visitTime ? `${this.form.visitDay} ${this.form.visitTime}` : this.form.visitDay || ''
        }, 'mobile-home')

        if (result.success) {
          alert(`${this.form.name}님, 상담 신청이 완료되었습니다.\n빠른 시일 내에 연락드리겠습니다.`)
          this.form = { name: '', phone1: '010', phone2: '', phone3: '', visitDay: '', visitTime: '', agree: false }
        } else {
          alert('오류가 발생했습니다. 다시 시도해주세요.')
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.mobile-images {
  width: 100%;
}

.image-wrapper {
  width: 100%;
  line-height: 0;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

/* 사업개요 표 */
.info-table-section {
  padding: 40px 20px;
  background: #f8f9fa;
}

.info-table-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 24px;
  letter-spacing: -0.5px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  border-top: 2px solid var(--main-color1);
}

.info-table th,
.info-table td {
  padding: 14px 12px;
  font-size: 13px;
  line-height: 1.6;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  vertical-align: top;
}

.info-table th {
  width: 90px;
  font-weight: 600;
  color: #333;
  background: #f0f2f5;
  white-space: nowrap;
}

.info-table td {
  color: #555;
}

/* 하단 인라인 폼 */
.inline-form-section {
  width: 100%;
  padding: 48px 24px 60px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  position: relative;
  overflow: hidden;
}

.inline-form-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(44, 79, 126, 0.15) 0%, transparent 60%);
  animation: pulse-bg 4s ease-in-out infinite;
}

@keyframes pulse-bg {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 1; }
}

.form-header {
  position: relative;
  z-index: 2;
  text-align: center;
  margin-bottom: 28px;
}

.form-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--main-color1);
  margin-bottom: 14px;
}

.form-title {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
}

.form-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
}

/* 폼 */
.register-form {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 360px;
  margin: 0 auto;
}

.form-group input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  font-size: 15px;
  font-family: inherit;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  transition: border-color 0.2s;
}

.form-group input:focus {
  outline: none;
  border-color: var(--main-color1);
  background: rgba(255, 255, 255, 0.15);
}

.form-group input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

/* 방문예약 일자/시간 */
.field-label {
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 6px;
}

.visit-inputs {
  display: flex;
  gap: 8px;
}

.visit-field {
  flex: 1;
  position: relative;
  min-width: 0;
}

.visit-field input {
  width: 100%;
  color: transparent;
}

.visit-field input:valid,
.visit-field input:not([value=""]) {
  color: #fff;
}

.visit-placeholder {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  pointer-events: none;
}

.visit-field input::-webkit-calendar-picker-indicator {
  filter: invert(1);
  opacity: 0.5;
}

/* 전화번호 3칸 */
.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.phone-dash {
  color: rgba(255, 255, 255, 0.4);
  font-size: 16px;
  flex-shrink: 0;
}

/* 체크박스 */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  padding: 8px 0;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.checkbox-label input:checked + .checkmark {
  background: var(--main-color1);
  border-color: var(--main-color1);
}

.checkbox-label input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* 제출 버튼 */
.submit-btn {
  width: 100%;
  padding: 16px;
  background: var(--main-color1);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 4px;
}

.submit-btn:active:not(:disabled) {
  background: var(--main-color2);
  transform: scale(0.98);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
